import {
	MODULE_NAME,
	COMPANIES,
	SET_COMPANIES,
	CUSTOMERS,
	SET_CUSTOMERS,
	VENDORS,
	SET_VENDORS,
	INTEGRATIONS_OPTIONS,
	SET_INTEGRATIONS_OPTIONS,
	REQUEST_TYPES,
	SET_REQUEST_TYPES,
	OEM_LOGS,
	SET_OEM_LOGS,
	STATES,
	SET_STATES,
	CLEAR_COMPANIES,
	ENVIRONMENTS,
	SET_ENVIRONMENTS,
	SET_USER_OPTIONS,
	SET_CCL_OPTIONS,
	ALL_ROLES,
	SET_ALL_ROLES,
	INTERNAL_ROLES_OPTS,
	CONSULTANT_ROLES_OPTS,
	SET_INTERNAL_ROLES_OPTS,
	SET_CONSULTANT_ROLES_OPTS
} from './options-mutation-type';

import { TOAST_MESSAGES_PUSH } from '@/store/modules/mutation-types';

import { ApiService as api } from '@/services/axiosHelper';
import { ApiLogService as apiLog } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';
import { mergePayloadObjects } from '@/utils/object';
import _ from 'lodash';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: MODULE_NAME,
	namespaced: true,
	state: {
		[COMPANIES]: {},
		[CUSTOMERS]: {},
		[VENDORS]: {},
		[INTEGRATIONS_OPTIONS]: {},
		[REQUEST_TYPES]: [],
		[OEM_LOGS]: {},
		[STATES]: [],
		[ENVIRONMENTS]: {},
		userOptions: {},
		cclOptions: {},
		[ALL_ROLES]: {},
		[INTERNAL_ROLES_OPTS]: {},
		[CONSULTANT_ROLES_OPTS]: {}
	},
	mutations: {
		[SET_COMPANIES](state, data) {
			state[COMPANIES] = data;
		},
		[SET_CUSTOMERS](state, data) {
			state[CUSTOMERS] = data;
		},
		[CLEAR_COMPANIES](state) {
			state[COMPANIES] = {};
		},
		[SET_VENDORS](state, data) {
			state[VENDORS] = data;
		},
		[SET_INTEGRATIONS_OPTIONS](state, obj) {
			state[INTEGRATIONS_OPTIONS] = obj;
		},
		[SET_REQUEST_TYPES](state, data) {
			state[REQUEST_TYPES].push(data);
		},
		[SET_OEM_LOGS](state, data) {
			state[OEM_LOGS] = data;
		},
		[SET_STATES](state, data) {
			state[STATES] = data;
		},
		[SET_ENVIRONMENTS](state, data) {
			state[ENVIRONMENTS] = data;
		},
		[SET_USER_OPTIONS](state, data) {
			state.userOptions = data;
		},
		[SET_CCL_OPTIONS](state, data) {
			state.cclOptions = data;
		},
		[SET_ALL_ROLES](state, data) {
			state[ALL_ROLES] = data;
		},
		[SET_INTERNAL_ROLES_OPTS](state, data) {
			state[INTERNAL_ROLES_OPTS] = data;
		},
		[SET_CONSULTANT_ROLES_OPTS](state, data) {
			state[CONSULTANT_ROLES_OPTS] = data;
		}
	},
	actions: {
		async [SET_COMPANIES]({ commit }, parameters) {
			const results = await api
				.get(buildRoute(`/${MODULE_NAME}/companies`, parameters))
				.catch();
			commit(SET_COMPANIES, results);

			return results;
		},
		async [SET_CUSTOMERS]({ commit }, parameters) {
			const results = await api
				.get(buildRoute(`/${MODULE_NAME}/customers`, parameters || {}))
				.catch();
			commit(SET_CUSTOMERS, results);

			return results;
		},
		async getCustomers({ commit, dispatch }, parameters) {
			return new Promise((resolve, reject) => {
				api.get('/options/customers', {
					parameters
				})
					.then(res => {
						commit(SET_CUSTOMERS, res);
						resolve();
					})
					.catch(err => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: err
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		async getCompanies({ commit, dispatch }, customerId) {
			// options/companies?customerId=897601b7-adc7-4ab9-9290-53676c52be0c
			return new Promise((resolve, reject) => {
				api.get(`/options/companies?customerId=${customerId}`)
					.then(res => {
						commit(SET_COMPANIES, res);
						resolve();
					})
					.catch(err => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: err
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		async [SET_VENDORS]({ commit }, parameters) {
			if (_.isEmpty(parameters)) {
				parameters = {
					IntegratorTypesId: 4
				};
			}
			const results = await api
				.get(buildRoute(`/${MODULE_NAME}/vendors`, parameters))
				.catch();
			commit(SET_VENDORS, results);
			return results;
		},
		async [SET_INTEGRATIONS_OPTIONS]({ commit, dispatch }, params) {
			return new Promise((resolve, reject) => {
				api.get(buildRoute('/options/integrations', params))
					.then(res => {
						commit(SET_INTEGRATIONS_OPTIONS, res);
						resolve();
					})
					.catch(err => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: err
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		async [SET_REQUEST_TYPES]({ commit, state }, parameters) {
			const searchName = parameters.propertyName;
			const rt = state[REQUEST_TYPES].find(x => x.name == searchName);
			if (rt) {
				return {
					name: searchName,
					data: rt.data
				};
			}

			const results = await apiLog.get(
				buildRoute(`/options/logs`, parameters)
			);
			commit(SET_REQUEST_TYPES, {
				name: searchName,
				data: results
			});

			return results;
		},
		async [SET_OEM_LOGS]({ commit }) {
			const results = await apiLog.get(buildRoute(`/oemlog`)).catch();
			commit(SET_OEM_LOGS, results.items);

			return results;
		},
		async [SET_STATES]({ commit }) {
			const results = await api
				.get(buildRoute(`/${MODULE_NAME}/states`))
				.catch();
			commit(SET_STATES, results.items);
			return results;
		},
		async [SET_ENVIRONMENTS]({ commit }, parameters) {
			const results = await api
				.get(buildRoute(`/${MODULE_NAME}/environments`, parameters))
				.catch();
			commit(SET_ENVIRONMENTS, results.items);
			return results;
		},
		async getUsersOptions({ state, commit, dispatch }, params) {
			return new Promise((resolve, reject) => {
				const { page } = params;
				if (page === 1) {
					commit(SET_USER_OPTIONS, {});
				}

				api.get('/options/users', { params })
					.then(res => {
						if (_.isEmpty(state.userOptions)) {
							commit(SET_USER_OPTIONS, res);
						} else {
							let userOptionsStore = _.cloneDeep(
								state.userOptions
							);
							let userOptionsPayload = mergePayloadObjects(
								userOptionsStore,
								res
							);
							commit(SET_USER_OPTIONS, userOptionsPayload);
						}
						resolve();
					})
					.catch(error => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: error
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		async getCCLOptions({ state, commit, dispatch }, params) {
			return new Promise((resolve, reject) => {
				const { page } = params;
				if (page === 1) {
					commit(SET_CCL_OPTIONS, {});
				}

				api.get('/options/ccl', { params })
					.then(res => {
						if (_.isEmpty(state.cclOptions)) {
							commit(SET_CCL_OPTIONS, res);
						} else {
							let cclOptionsStore = _.cloneDeep(state.cclOptions);
							let cclOptionsPayload = mergePayloadObjects(
								cclOptionsStore,
								res
							);
							commit(SET_CCL_OPTIONS, cclOptionsPayload);
						}
						resolve();
					})
					.catch(error => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: error
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		async getRolesOptions(
			{ state, commit, dispatch },
			{ clientId, ...params }
		) {
			const { page } = params;
			const roleOpts = {
				'vue-support-portal': INTERNAL_ROLES_OPTS,
				'vue-support-external': CONSULTANT_ROLES_OPTS,
				undefined: ALL_ROLES
			};
			const setRoleOpts = {
				'vue-support-portal': SET_INTERNAL_ROLES_OPTS,
				'vue-support-external': SET_CONSULTANT_ROLES_OPTS,
				undefined: SET_ALL_ROLES
			};

			if (page === 1) {
				if (!clientId) {
					commit(SET_ALL_ROLES, {});
				}
				if (clientId === 'vue-support-portal') {
					commit(SET_INTERNAL_ROLES_OPTS, {});
				}
				if (clientId === 'vue-support-external') {
					commit(SET_CONSULTANT_ROLES_OPTS, {});
				}
			}

			api.get(buildRoute('/options/roles', { clientId, ...params }))
				.then(res => {
					const { items } = res;
					if (!_.isEmpty(items)) {
						const itemsSorted = _.sortBy(
							_.filter(items, { active: true }),
							'text'
						);
						res.items = itemsSorted;
					}
					if (_.isEmpty(state[roleOpts[clientId]])) {
						commit(setRoleOpts[clientId], res);
					} else {
						let rolesOptionsStore = _.cloneDeep(
							state[roleOpts[clientId]]
						);
						let rolesOptionsPayload = mergePayloadObjects(
							rolesOptionsStore,
							res
						);
						commit(setRoleOpts[clientId], rolesOptionsPayload);
					}
				})
				.catch(error => {
					dispatch(
						TOAST_MESSAGES_PUSH,
						{
							statusCode: 400,
							message: error
						},
						{
							root: true
						}
					);
				});
		}
	},
	getters: {
		[COMPANIES]: state => state[COMPANIES],
		[CUSTOMERS]: state => state[CUSTOMERS],
		customerItems: state => {
			const customers = [];

			if (!state.OptionsCustomers.items) {
				return [];
			}

			state.OptionsCustomers.items?.forEach(customer => {
				customers.push({
					text: customer.text,
					value: customer.value
				});
			});

			return customers;
		},
		companyItems: state => {
			const companies = [];

			if (!state.OptionsCustomers.items) {
				return [];
			}

			state.OptionsCompanies.items?.forEach(company => {
				companies.push({
					text: company.text,
					value: company.value
				});
			});

			return companies;
		},
		[VENDORS]: state => state[VENDORS],
		[REQUEST_TYPES]: state => value =>
			state[REQUEST_TYPES].find(x => x.name == value)?.data.items,
		[OEM_LOGS]: state => state[OEM_LOGS],
		[STATES]: state => state[STATES],
		[ENVIRONMENTS]: state => state[ENVIRONMENTS],
		indexByEnvironmentId: state => id => {
			if (
				!state.OptionsEnvironments ||
				!Array.isArray(state.OptionsEnvironments)
			) {
				return -1;
			}
			return state.OptionsEnvironments.findIndex(
				environment => environment.value === id.toString()
			);
		},
		showZoneIndicator: state => id => {
			if (_.isEmpty(state[ENVIRONMENTS])) {
				return false;
			}
			return !state[ENVIRONMENTS].some(
				env => parseInt(env.value) === id && env.text === 'vue'
			);
		}
	}
};
